// src/utils/countries.ts

export const COUNTRIES = [
  { value: 'NG', label: 'Nigeria' },
  { value: 'GH', label: 'Ghana' },
  { value: 'KE', label: 'Kenya' },
  { value: 'UG', label: 'Uganda' },
  { value: 'SN', label: 'Senegal' },
  { value: 'CI', label: 'Ivory Coast' },
];

export const getCurrency = (countryCode?: string) => {
  switch (countryCode?.toUpperCase()) {
    case 'GH':
      return 'GH₵';
    case 'NG':
      return '₦';
    case 'KE':
      return 'Ksh';
    case 'UG':
      return 'Ush';
    case 'CI':
      return 'XOF';
    case 'SN':
      return 'XOF';
    case 'EG':
      return 'E£';
    default:
      return '₦';
  }
};

export const getCountryLabel = (countryCode: string): string => {
  const country = COUNTRIES.find(c => c.value === countryCode);
  return country?.label || countryCode;
};